<template><div><dt-notice kind="warning" title="Use DtText over CSS Utilities" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Reach for the <a href="/components/text" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtText</a> component before considering any typography utility.
</dt-notice>
<h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;p class=&quot;d-fs-{stop}&quot;&gt;...&lt;/p&gt;'>
<div class="d-d-grid d-g-200 d-ai-baseline" style="grid-template-columns: 10rem 1fr">
  <div class="d-code--sm d-docsite-code">d-fs-50</div><div><p class="d-lc-1 d-fs-50">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-75</div><div><p class="d-lc-1 d-fs-75">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-100</div><div><p class="d-lc-1 d-fs-100">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-125</div><div><p class="d-lc-1 d-fs-125">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-150</div><div><p class="d-lc-1 d-fs-150">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-200</div><div><p class="d-lc-1 d-fs-200">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-250</div><div><p class="d-lc-1 d-fs-250">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-300</div><div><p class="d-lc-1 d-fs-300">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-350</div><div><p class="d-lc-1 d-fs-350">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-400</div><div><p class="d-lc-1 d-fs-400">The quick brown fox jumps over the lazy dog.</p></div>
  <div class="d-code--sm d-docsite-code">d-fs-500</div><div><p class="d-lc-1 d-fs-500">The quick brown fox jumps over the lazy dog.</p></div>
</div>
</code-example>
<h2 id="classes-by-platform" tabindex="-1" class="d-docsite--header-2">Classes by Platform <a class="header-anchor d-link d-docsite--link d-link" href="#classes-by-platform" aria-hidden="true">#</a></h2>
<h3 id="product" tabindex="-1" class="d-docsite--header-3">Product <a class="header-anchor d-link d-docsite--link d-link" href="#product" aria-hidden="true">#</a></h3>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
        <tr>
          <th scope="col" class="d-p-0 d-bbw0 d-w10p"><div class="d-p-200 d-bb d-bbw1">Size</div></th>
          <th scope="col" class="d-p-0 d-bbw0 d-w20p"><div class="d-p-200 d-bb d-bbw1">Class</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Output</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ stop, size, output } in fontSize.product">
          <th scope="row">{{ size }}px</th>
          <td class="d-code--sm d-docsite-code">.d-fs-{{ stop }}</td>
          <td>
            <dt-stack direction="row" justify="between" align="center">
              <div class="d-fl1 d-code--sm">
                font-size: {{ output }}rem !important;
              </div>
              <div class="d-fl0 d-lh4" :class="`d-fs-${stop}`">
                Aa
              </div>
            </dt-stack>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
<h3 id="mobile" tabindex="-1" class="d-docsite--header-3">Mobile <a class="header-anchor d-link d-docsite--link d-link" href="#mobile" aria-hidden="true">#</a></h3>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
        <tr>
          <th scope="col" class="d-p-0 d-bbw0 d-w10p"><div class="d-p-200 d-bb d-bbw1">Size</div></th>
          <th scope="col" class="d-p-0 d-bbw0 d-w20p"><div class="d-p-200 d-bb d-bbw1">Class</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Output</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ stop, size, output } in fontSize.mobile">
          <th scope="row">{{ size }}px</th>
          <td class="d-code--sm d-docsite-code">.d-fs-{{ stop }}-mobile</td>
          <td>
            <dt-stack direction="row" justify="between" align="center">
              <div class="d-fl1 d-code--sm">
                font-size: {{ output }}rem !important;
              </div>
              <div class="d-fl0 d-lh4" :class="`d-fs-${stop}-mobile`">
                Aa
              </div>
            </dt-stack>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
<h3 id="tc8" tabindex="-1" class="d-docsite--header-3">TC8 <a class="header-anchor d-link d-docsite--link d-link" href="#tc8" aria-hidden="true">#</a></h3>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
        <tr>
          <th scope="col" class="d-p-0 d-bbw0 d-w10p"><div class="d-p-200 d-bb d-bbw1">Size</div></th>
          <th scope="col" class="d-p-0 d-bbw0 d-w20p"><div class="d-p-200 d-bb d-bbw1">Class</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Output</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ stop, size, output } in fontSize.tc8">
          <th scope="row">{{ size }}px</th>
          <td class="d-code--sm d-docsite-code">.d-fs-{{ stop }}-tc8</td>
          <td>
            <dt-stack direction="row" justify="between" align="center">
              <div class="d-fl1 d-code--sm">
                font-size: {{ output }}rem !important;
              </div>
              <div class="d-fl0 d-lh4" :class="`d-fs-${stop}-tc8`">
                Aa
              </div>
            </dt-stack>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
<h3 id="tv" tabindex="-1" class="d-docsite--header-3">TV <a class="header-anchor d-link d-docsite--link d-link" href="#tv" aria-hidden="true">#</a></h3>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
        <tr>
          <th scope="col" class="d-p-0 d-bbw0 d-w10p"><div class="d-p-200 d-bb d-bbw1">Size</div></th>
          <th scope="col" class="d-p-0 d-bbw0 d-w20p"><div class="d-p-200 d-bb d-bbw1">Class</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Output</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ stop, size, output } in fontSize.tv">
          <th scope="row">{{ size }}px</th>
          <td class="d-code--sm d-docsite-code">.d-fs-{{ stop }}-tv</td>
          <td>
            <dt-stack direction="row" justify="between" align="center">
              <div class="d-fl1 d-code--sm">
                font-size: {{ output }}rem !important;
              </div>
              <div class="d-fl0 d-lh4" :class="`d-fs-${stop}-tv`">
                Aa
              </div>
            </dt-stack>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
</div></template>


<script setup>
  import { fontSize } from '@data/type.json';
  import ClampedTableWrapper from '@baseComponents/ClampedTableWrapper.vue';
</script>